var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsInt, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { CustomFormElementType } from '../enums/custom-form-element-type.enum.js';
class Options {
    id;
    value;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], Options.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], Options.prototype, "value", void 0);
export class CustomFormElementLiteDto {
    id;
    createdAt;
    updatedAt;
    label;
    /** @deprecated Used for migration from legacy Anamnesis to CustomForm */
    migrationLabel;
    index;
    options;
    mandatory;
    isNewlyCreated;
    type;
    customFormId;
    imageFilename;
    description;
    placeholder;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormElementLiteDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormElementLiteDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormElementLiteDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormElementLiteDto.prototype, "label", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", Object)
], CustomFormElementLiteDto.prototype, "migrationLabel", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], CustomFormElementLiteDto.prototype, "index", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Options),
    __metadata("design:type", Array)
], CustomFormElementLiteDto.prototype, "options", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormElementLiteDto.prototype, "mandatory", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormElementLiteDto.prototype, "isNewlyCreated", void 0);
__decorate([
    Expose(),
    IsEnum(CustomFormElementType),
    __metadata("design:type", String)
], CustomFormElementLiteDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormElementLiteDto.prototype, "customFormId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementLiteDto.prototype, "imageFilename", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementLiteDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementLiteDto.prototype, "placeholder", void 0);
//# sourceMappingURL=custom-form-element.lite.dto.js.map